import React, { Fragment } from 'react'
import quickDelivery from '../../Assets/Images/quickDelivery.png'
import bestQuality from '../../Assets/Images/bestQuality.png'
import returngurantee from '../../Assets/Images/returngurantee.png'
import securepayment from '../../Assets/Images/securepayment.png'

const Features = () => {
    return (
        <Fragment>
            <section className='bg-dark py-5 feature-section'>
                <div className="container py-5">
                    <div className="row">
                        <div className="col-lg-3">

                            <div style={{ height: "70px", width: "40px" }} >
                                <img src={quickDelivery} className='mb-4' width={"40px"} alt="" />
                            </div>
                            <h6 className='text-light'>Quick Delivery</h6>
                            <p className='text-light'>
                                <small>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </small>
                            </p>
                        </div>

                        <div className="col-lg-3">

                            <div style={{ height: " 70px", width: "40px" }} >
                                <img src={securepayment} className='mb-4' width={"40px"} alt="" />

                            </div>
                            <h6 className='text-light'>Secure Payment</h6>
                            <p className='text-light'>
                                <small>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </small>
                            </p>
                        </div>

                        <div className="col-lg-3">
                            <div style={{ height: "70px", width: "40px" }} >
                                <img src={bestQuality} className='mb-4' width={"40px"} alt="" />

                            </div>

                            <h6 className='text-light'>Best Quality</h6>
                            <p className='text-light'>
                                <small>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </small>
                            </p>
                        </div>

                        <div className="col-lg-3">
                            <div style={{ height: " 70px", width: "40px" }} >

                                <img src={returngurantee} className='mb-4' width={"100%"} alt="" />
                            </div>

                            <h6 className='text-light'>Return Gurantee</h6>
                            <p className='text-light'>
                                <small>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </small>
                            </p>
                        </div>


                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default Features